import React from "react";
import { styled } from "styled-components";
import { RadioBox } from "../RadioBox";
import OrderDateRadioBoxBody from "./components/OrderDateRadioBoxBody";
const Container = styled.div `
  display: flex;
  width: 8rem;

  > div {
    display: flex;
    align-items: stretch;
    flex: 1;
  }
`;
export const OrderDateRadioBox = React.forwardRef(({ checked, date, description, label, locale, name, onChange, value, highlighted = false, icon, ...inputProps }, ref) => (React.createElement(Container, null,
    React.createElement(RadioBox, { ...inputProps, body: () => (React.createElement(OrderDateRadioBoxBody, { icon: icon, date: date, locale: locale, description: description, checked: checked, highlighted: highlighted })), centered: true, checked: checked, label: label, name: name, onChange: onChange, ref: ref, value: value, highlighted: highlighted }))));
export default OrderDateRadioBox;
//# sourceMappingURL=OrderDateRadioBox.js.map